export const perpTheme = (isDark: boolean) => {
  return 'dark'
}
